<template>
  <section class="section-advertiseWithUs">
    <div class="container">
      <div class="section-space-50"></div>

      <ul class="list-inline mx-auto fnb-page-List text-center">
        <li class="list-inline-item">
          <button
            class="btn rounded-10 font-weight-600 w-100"
            :class="
              tab1 ? 'btn-primary text-white' : 'btn-outline-primary text-white'
            "
            @click.prevent="showTabs('tab1')"
          >
            Advertise with us
          </button>
        </li>

        <!-- <li class="list-inline-item">
          <button
            class="btn rounded-10 font-weight-600 w-100"
            :class="
              tab2 ? 'btn-primary text-white' : 'btn-outline-primary text-white'
            "
            @click.prevent="showTabs('tab2')"
          >
            Why cinema Advertising
          </button>
        </li> -->
        <li class="list-inline-item">
          <button
            class="btn rounded-10 font-weight-600 w-100"
            :class="
              tab3 ? 'btn-primary text-white' : 'btn-outline-primary text-white'
            "
            @click.prevent="showTabs('tab3')"
          >
            Why Miraj Cinemas?
          </button>
        </li>

        <li class="list-inline-item">
          <button
            class="btn rounded-10 font-weight-600 w-100"
            :class="
              tab4 ? 'btn-primary text-white' : 'btn-outline-primary text-white'
            "
            @click.prevent="showTabs('tab4')"
          >
            Advertising
          </button>
        </li>
      </ul>

      <div class="section-space-50"></div>

      <!-- ADVERTISE WITH US START -->
      <div v-if="tab1">
        <div class="row">
          <div class="col-lg-8 mb-3 mb-md-0">
            <div class="section-header-title">Advertise with us</div>

            <div>
              <slick :options="aboutUsSlider">
                <!-- <div>
                  <img
                    src="../../assets/img/advertisingImages/image-1.1.jpeg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-2.1.jpeg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-3.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-4.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-5.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-6.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-7.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-8.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-9.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-10.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-11.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-12.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-13.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div> -->
                <div>
                  <img
                    src="../../assets/img/advertisingImagesNew/Audi-door.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImagesNew/Cine-Pass.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImagesNew/Lift.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImagesNew/Popcorner-Standee.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImagesNew/Seat-Branding.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImagesNew/Video-Wall.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImagesNew/Washroom-Branding.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
              </slick>
            </div>
            <template v-if="ad_with_us">
              <div v-html="ad_with_us"></div>
            </template>
            <template v-else>
              <p class="my-4 my-md-5">
                Miraj ventured in Cinema Exhibition business in the year 2012 & within 10 years of its 
                inception Miraj cinemas grew to 176 screens across 43 cities and 15 states in India. 
                Miraj cinema have received several recognition including, 'Fastest Growing Cinema Chain', 
                'Best Marketing Initiative' & Best Chain National amongst several others. 
                We are here to help you grow your brand!
              </p>
            </template>
            <!-- <div v-html="ad_with_us"></div> -->
          </div>

          <div class="col-lg-4">
            <div class="feedbackForm py-4 px-3 mb-4">
              <h5 class="mb-4 font-weight-bold">Sales &amp; Promotion</h5>
              <ul class="list-inline fs-14 mb-0">
                <li class="list-inline-item mb-2 mob-fs-14">
                  <img src="@/assets/img/icons/callIcon.svg" class="mr-2" alt />
                  +91 - 84694 75640
                </li>
                <li class="mob-fs-14">
                  <img
                    src="@/assets/img/icons/emailIcon.svg"
                    class="mr-2"
                    alt
                  />
                  <template v-if="customer_care_email">
                    {{ plainEmail }}
                  </template>
                  <template v-else>
                    <span>contactus@mirajcinemas.com</span>
                  </template>
                </li>
              </ul>
            </div>
            <div class="feedbackForm py-4 px-3 px-md-4">
              <h5 class="mb-4 font-weight-bold">Request for advertising</h5>
              <!-- @click.stop.prevent="handleSubmit" -->
              <form @submit.stop.prevent="handleSubmit()">
                <div class="mb-3">
                  <p class="mb-1">
                    Full Name
                    <span class="text-danger">*</span>
                  </p>
                  <input
                    placeholder="Name"
                    type="text"
                    required
                    class="form-control"
                    v-model="user_name"
                  />
                </div>

                <div class="mb-3">
                  <p class="mb-1">
                    Phone Number
                    <span class="text-danger">*</span>
                  </p>
                  <input
                    placeholder="Mobile Number"
                    type="number"
                    ref="mobileNumber"
                    required
                    class="form-control"
                    v-model="user_number"
                    maxlength="10"
                    onkeyup="this.value=this.value.replace(/[^0-9]+/g,'');"
                    onkeypress="if(this.value.length==10) return false;"
                  />
                  <p class="text-danger" v-if="errorMessage">{{errorMessage}}</p>
                </div>

                <div class="mb-3">
                  <p class="mb-1">
                    Email address
                    <span class="text-danger">*</span>
                  </p>
                  <input
                    placeholder="Email"
                    type="email"
                    required
                    class="form-control"
                    v-model="user_email"
                    ref="emailAddress"
                  />
                  <p class="text-danger" v-if="errorEmail">{{errorEmail}}</p>
                </div>

                <div class="mb-3">
                  <p class="mb-1">
                    Organization name
                    <span class="text-danger">*</span>
                  </p>
                  <input
                    placeholder="Organization Name"
                    v-model="organization_name"
                    type="text"
                    required
                    class="form-control"
                  />
                </div>

                <div class="mb-3">
                  <p class="mb-1">
                    Your message
                    <span class="text-danger">*</span>
                  </p>
                  <textarea
                    placeholder="Type here"
                    v-model="message"
                    required
                    name
                    id
                    cols="30"
                    class="form-control"
                    rows="6"
                  ></textarea>
                </div>
                <div class="text-center text-left">
                  <button class="btn btn-primary mt-4 px-5" type="submit">
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- ADVERTISE WITH US END -->

      <!-- WHY CINEMA ADVERTISING START -->
      <!-- <div v-if="tab2">
        <div class="row">
          <div class="col-12">
            <div class="section-header-title">Why cinema Advertising?</div>
            <p>
              Nothing brings people together like a movie. The excitement of
              sharing an experience with your loved ones and the escape from the
              hustle-bustle; that feeling is unparalleled. A great bonding
              activity for families, friends, couples, and peer groups;
              cinemahasfor long been successful in gluing people and therefore,
              always rates much more than other entertainment avenues. In the
              ever busy world of today, this 'Together time' is hard to find and
              harder for a marketer to penetrate. Cinema provides a state of
              mind that exists in no other medium, with the audience being more
              open and wilfully looking forward to everything that’s coming
              their way.
            </p>
          </div>
        </div>
      </div> -->
      <!-- WHY CINEMA ADVERTISING END -->

      <!-- WHY MIRAJ CINEMAS START -->
      <div v-if="tab3">
        <div class="row">
          <div class="col-12">
            <div class="section-header-title">Why cinema Advertising?</div>
            <p>
              Nothing brings people together like a movie. The excitement of
              sharing an experience with your loved ones and the escape from the
              hustle-bustle; that feeling is unparalleled. A great bonding
              activity for families, friends, couples, and peer groups;
              cinemahasfor long been successful in gluing people and therefore,
              always rates much more than other entertainment avenues. In the
              ever busy world of today, this 'Together time' is hard to find and
              harder for a marketer to penetrate. Cinema provides a state of
              mind that exists in no other medium, with the audience being more
              open and wilfully looking forward to everything that’s coming
              their way.
            </p>
          </div>

          <div class="col-12">
            <div class="section-header-title">
              Why should you advertise at Miraj Cinemas?
            </div>

            <!-- <ol class="pl-3 pl-md-4 pl-lg-5">
              <li>
                Confined Audience: All eyes on the screen, 100% focus on
                advertising communication.
              </li>
              <li>
                Influential – has a larger than life visual impact compared to
                TV or Radio.
              </li>
              <li>Delivers both; Local and National reach.</li>
              <li>Brand Messages are perceived as a part of the experience.</li>
              <li>Greater Advertising recall.</li>
              <li>Low avoidance due to low distractions.</li>
              <li>
                Focused Target Group Profiling: The genre of the movie
                determines the audience.
              </li>
              <li>
                Stunning Impact: The best screen size for projection clarity.
              </li>
              <li>
                Audio-Visual quality: High Definition Audio and Visual Quality.
              </li>
              <li>
                Zero Wastage; Maximum Value for Money: Ads are only displayed
                onscreen once the audience are in their seats.
              </li>
              <li>
                Higher Attention Span: Consumer is more amenable to advertising
                communication.
              </li>
              <li>
                Variety of advertising options: Multiple advertising
                opportunities to effectively target the consumer at various
                touchpoints from entry to exit.
              </li>
            </ol> -->

            <!-- <div>
              <img
                src="@/assets/img/Advertise-miraj.png"
                class="img-fluid w-100 rounded p-2 d-table"
                alt
              />
            </div> -->

            <div class="row">
              <div class="col-12 col-md-3">
                <div class="border shadow h-100 px-3 py-3 bg-white">
                  <h2 class="text-rose-gold font-weight-bold">
                    WHY CINEMA ADVERTISING
                  </h2>
                  <div class="text-dark">
                    Cinema is a catalyst to 'together time' for couples,
                    families, friends and peer groups and hence the experience
                    of bonding over the shared experience of a film rates much
                    more than other entertainment avenues. This 'Together time'
                    is hard to find and harder for a marketer to penetrate.
                    Cinema provides a state of mind that exists in no other
                    medium. The audience gets into the most receptive frame of
                    mind owing to voluntary surrender to the environment.
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-9">
                <!-- <div class="row">
                  <div>
                    <div class="col-3"></div>
                  </div>
                </div> -->
                <div class="row add-cards">
                  <div class="col mb-3">
                    <div class="add-card">
                      <h1 class="add-number">1</h1>
                      <h6 class="add-title">CAPTIVE AUDIENCE</h6>
                      <hr />
                      <p class="add-txt">
                        100% focus on advertising communication.
                      </p>
                    </div>
                  </div>
                  <div class="col mb-3">
                    <div class="add-card">
                      <h1 class="add-number">2</h1>
                      <h6 class="add-title">BETTER IMPACT</h6>
                      <hr />
                      <p class="add-txt">
                        Larger than life visual impact compared to TV or Radio
                      </p>
                    </div>
                  </div>
                  <div class="col mb-3">
                    <div class="add-card">
                      <h1 class="add-number">3</h1>
                      <h6 class="add-title">GREATER REACH</h6>
                      <hr />
                      <p class="add-txt">
                        Ability to deliver nation-wide as well as local reach.
                      </p>
                    </div>
                  </div>
                  <div class="col mb-3">
                    <div class="add-card">
                      <h1 class="add-number">4</h1>
                      <h6 class="add-title">NON-OBSTRUSIVE</h6>
                      <hr />
                      <p class="add-txt">
                        Cinema Goers perceive the ads as part of the experience.
                      </p>
                    </div>
                  </div>
                  <div class="col mb-3">
                    <div class="add-card">
                      <h1 class="add-number">5</h1>
                      <h6 class="add-title">FOCUSED TARGET GROUP</h6>
                      <hr />
                      <p class="add-txt">
                        Genre of the movie determines the audience.
                      </p>
                    </div>
                  </div>
                  <div class="w-100"></div>
                  <div class="col mb-3">
                    <div>
                      <h1 class="add-number">6</h1>
                      <h6 class="add-title">BENEFITS OF CINEMA TECH</h6>
                      <hr />
                      <p class="add-txt">
                        Screen size and projection clarity add greatly to the
                        experience
                      </p>
                    </div>
                  </div>
                  <div class="col mb-3">
                    <div>
                      <h1 class="add-number">7</h1>
                      <h6 class="add-title">HIGH AV QUALITY</h6>
                      <hr />
                      <p class="add-txt">
                        High definition Audio and Visual Quality.
                      </p>
                    </div>
                  </div>
                  <div class="col mb-3">
                    <div>
                      <h1 class="add-number">8</h1>
                      <h6 class="add-title">ZERO WASTAGE</h6>
                      <hr />
                      <p class="add-txt">
                        Ads are only displayed onscreen once the audience is in
                      </p>
                    </div>
                  </div>
                  <div class="col mb-3">
                    <div>
                      <h1 class="add-number">9</h1>
                      <h6 class="add-title">BETTER RETENTION</h6>
                      <hr />
                      <p class="add-txt">
                        Consumer is at leisure and more amenable to the
                        advertising communication.
                      </p>
                    </div>
                  </div>
                  <div class="col mb-3">
                    <div>
                      <h1 class="add-number">10</h1>
                      <h6 class="add-title">VARIETY OF OPTIONS</h6>
                      <hr />
                      <p class="add-txt">
                        To effectively target the consumer at various touch
                        points from entry to exit.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div>
              <slick :options="aboutUsSliderNew">
                <div>
                  <img
                    src="@/assets/img/Advertise-miraj.png"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
              </slick>
            </div> -->
          </div>
        </div>
      </div>
      <!-- WHY MIRAJ CINEMAS END -->

      <!-- ADVERTISING START -->
      <div v-if="tab4">
        <div class="row">
          <div class="col-12">
            <div class="section-header-title">Advertising</div>

            <h5 class="font-weight-bold">On-screen Advertising:</h5>
            <p>
              On-screen advertising includes digital commercials or static
              slides that are played in the audi before the movie begins or
              during the interval.
            </p>

            <p>
              The average duration for a digital commercial is 30 secs. 10 secs
              for a static slide.
            </p>

            <h5 class="font-weight-bold">Off-screen Advertising:</h5>

            <!-- ACCORDION VIEW START-->
            <div role="tablist" class="tl-accordion">
              <b-card no-body class="mb-3">
                <b-card-header
                  header-tag="header"
                  class="p-3 tl-accordion-header cursor-pointer"
                  role="tab"
                >
                  <div
                    class="
                      w-100
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                    v-b-toggle.accordion-1
                  >
                    <div>Cinepass(Box Office), Outdoor &amp; Main Entrance</div>

                    <div>
                      <img src="@/assets/img/icons/down-arrow.svg" alt />
                      <!-- <img src="@/assets/img/icons/up-arrow.svg" alt /> -->
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  id="accordion-1"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <!-- visible -->
                  <b-card-body>
                    <b-card-text>
                      <div class="row">
                        <div class="col-12 col-md-7">
                          <ol class="pl-3 pl-md-4 pl-lg-5">
                            <li>Branding on box-office panels</li>
                            <li>Sampling of Posters at the box-office</li>
                            <li>Tent cards at the box-office</li>
                            <!-- <li>Glow boxes at the box-office</li> -->
                            <!-- <li>Digital plasmas posters at the box-office</li> -->
                            <li>Leaflet distribution</li>
                            <li>Ticket jackets</li>
                            <!-- <li>Products from box-office</li> -->
                            <li>Discount vouchers distribution</li>
                            <li>Branding on cue managers</li>
                            <!-- <li>Standee display at the box-office</li> -->
                            <li>Branding on Quick Tix Machines</li>
                            <!-- <li>Contest form distribution</li> -->
                            <li>Counter branding on box-office glass</li>
                            <li>Outdoors on main facades</li>
                            <!-- <li>Product displays on facades</li> -->
                            <!-- <li>Branding on facade panels</li> -->
                            <!-- <li>Cutouts on facades</li> -->
                            <!-- <li>Contra vision branding on main entry glass</li> -->
                            <!-- <li>Standees at the main entry</li> -->
                            <li>Gate arch at the main entry</li>
                            <li>Branding on entrance podium</li>
                            <li>Stickers on glass doors</li>
                            <!-- <li>Translites at the main entrance</li> -->
                            <li>Sampling of products from the main entry</li>
                            <li>Branding on ladies frisking zone</li>
                            <!-- <li>Branding on HHMD Machines</li> -->
                            <!-- <li>Branding on the uniform of security staff</li> -->
                            <!-- <li>Branding carpet at main entry passage</li> -->
                            <!-- <li>
                              Sample distribution from ladies frisking zone
                            </li> -->
                          </ol>
                        </div>

                        <div class="col-12 col-md-5">
                          <img
                            v-lazy="IMAGE_URL + image_1"
                            class="img-fluid w-100"
                            alt=""
                          />
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3">
                <b-card-header
                  header-tag="header"
                  class="p-3 tl-accordion-header cursor-pointer"
                  role="tab"
                >
                  <div
                    class="
                      w-100
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                    v-b-toggle.accordion-2
                  >
                    <div>In-Audi Branding</div>
                    <div>
                      <img src="@/assets/img/icons/down-arrow.svg" alt />
                      <!-- <img src="@/assets/img/icons/up-arrow.svg" alt /> -->
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <div class="row">
                        <div class="col-12 col-md-7">
                          <ol class="pl-3 pl-md-4 pl-lg-5">
                            <li>Branding on seats</li>
                            <li>Lucky seat branding</li>
                            <!-- <li>Vouchers under audi seats</li> -->
                            <li>Branding on audi stairs</li>
                            <li>Lucky seat announcements</li>
                          </ol>
                        </div>

                        <div class="col-12 col-md-5">
                          <img
                            v-lazy="IMAGE_URL + image_2"
                            class="img-fluid w-100"
                            alt=""
                          />
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3">
                <b-card-header
                  header-tag="header"
                  class="p-3 tl-accordion-header cursor-pointer"
                  role="tab"
                >
                  <div
                    class="
                      w-100
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                    v-b-toggle.accordion-3
                  >
                    <div>Lobby Branding</div>

                    <div>
                      <img src="@/assets/img/icons/down-arrow.svg" alt />
                      <!-- <img src="@/assets/img/icons/up-arrow.svg" alt /> -->
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  id="accordion-3"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <div class="row">
                        <div class="col-12 col-md-7">
                          <ol class="pl-3 pl-md-4 pl-lg-5">
                            <li>Standee in the main lobby</li>
                            <li>Translites in the main lobby</li>
                            <li>Backlits in the main lobby</li>
                            <li>Pillar branding in the main lobby</li>
                            <li>Big wall brandings in lobby</li>
                            <li>Posters on digital plasmas</li>
                            <li>Promos on digital plasmas</li>
                            <li>Kiosk promotion in lobby</li>
                            <li>Data generation activity with promoters</li>
                            <li>Product display in the main lobby</li>
                            <li>Sampling of products</li>
                            <li>Cutout displays in the lobby</li>
                            <li>Audi door branding</li>
                            <!-- <li>
                              Wall branding with plasma screens playing
                              exclusive clips of brand
                            </li> -->
                            <li>Floor stickers</li>
                            <!-- <li>Frames in lobby areas</li> -->
                            <!-- <li>Wall backlit branding</li> -->
                            <li>Gate arch at audi entrance</li>
                          </ol>
                        </div>

                        <div class="col-12 col-md-5">
                          <img
                            v-lazy="IMAGE_URL + image_3"
                            class="img-fluid w-100"
                            alt=""
                          />
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3">
                <b-card-header
                  header-tag="header"
                  class="p-3 tl-accordion-header cursor-pointer"
                  role="tab"
                >
                  <div
                    class="
                      w-100
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                    v-b-toggle.accordion-4
                  >
                    <div>Washroom Branding</div>

                    <div>
                      <img src="@/assets/img/icons/down-arrow.svg" alt />
                      <!-- <img src="@/assets/img/icons/up-arrow.svg" alt /> -->
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  id="accordion-4"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <div class="row">
                        <div class="col-12 col-md-7">
                          <ol class="pl-3 pl-md-4 pl-lg-5">
                            <li>Branding on washroom doors</li>
                            <li>Branding on washroom mirrors</li>
                            <li>Stickers on urinals in gents washrooms</li>
                            <li>Branding on tissue dispensers</li>
                            <li>Posters in frames installed at</li>
                            <li>the back of cubicle doors</li>
                            <li>Sanitized strips branding</li>
                            <li>Branding on toilet roll dispensers</li>
                            <li>Stickers on washroom panels</li>
                          </ol>
                        </div>

                        <div class="col-12 col-md-5">
                          <img
                            v-lazy="IMAGE_URL + image_4"
                            class="img-fluid w-100"
                            alt=""
                          />
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3">
                <b-card-header
                  header-tag="header"
                  class="p-3 tl-accordion-header cursor-pointer"
                  role="tab"
                >
                  <div
                    class="
                      w-100
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                    v-b-toggle.accordion-5
                  >
                    <div>Popcorner (F&B counter)</div>

                    <div>
                      <img src="@/assets/img/icons/down-arrow.svg" alt />
                      <!-- <img src="@/assets/img/icons/up-arrow.svg" alt /> -->
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  id="accordion-5"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <div class="row">
                        <div class="col-12 col-md-7">
                          <ol class="pl-3 pl-md-4 pl-lg-5">
                            <li>Danglers</li>
                            <li>Tiltalkers</li>
                            <li>Popcorn tub branding</li>
                            <li>Drop box branding</li>
                            <li>Staff uniform branding</li>
                            <li>Branding on candy panels</li>
                            <li>Branding on candy tray</li>
                            <li>Standees at Concession Counters</li>
                            <li>Product sampling from Concession Counters</li>
                            <li>Branding on Concession digital plasmas</li>
                            <li>Menu board branding</li>
                            <li>Backlit box at candy bar</li>
                            <!-- <li>Glow box at candy bar</li> -->
                            <li>Cash tray branding</li>
                          </ol>
                        </div>

                        <div class="col-12 col-md-5">
                          <img
                            v-lazy="IMAGE_URL + image_5"
                            class="img-fluid w-100"
                            alt=""
                          />
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!-- <b-card no-body class="mb-3">
                <b-card-header
                  header-tag="header"
                  class="p-3 tl-accordion-header cursor-pointer"
                  role="tab"
                >
                  <div
                    class="w-100 d-flex align-items-center justify-content-between"
                    v-b-toggle.accordion-6
                  >
                    <div>Main Entrance</div>

                    <div>
                      <img src="@/assets/img/icons/down-arrow.svg" alt />
                      <img src="@/assets/img/icons/up-arrow.svg" alt />
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  id="accordion-6"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <div class="row">
                        <div class="col-12 col-md-7">
                          <ol class="pl-3 pl-md-4 pl-lg-5">
                            <li>Contra vision branding on main entry glass</li>
                            <li>Standees at the main entry</li>
                            <li>Gate arch at the main entry</li>
                            <li>Branding on entrance podium</li>
                            <li>Stickers on glass doors</li>
                            <li>Translites at the main entrance</li>
                            <li>Sampling of products from the main entry</li>
                            <li>Branding on ladies frisking zone</li>
                            <li>Branding on HHMD Machines</li>
                            <li>Branding on the uniform of security staff</li>
                            <li>Branding carpet at main entry passage</li>
                            <li>
                              Sample distribution from ladies frisking zone
                            </li>
                          </ol>
                        </div>

                        <div class="col-12 col-md-5">
                          <img
                            v-lazy="IMAGE_URL + image_6"
                            class="img-fluid w-100 h-100"
                            alt=""
                          />
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card> -->
            </div>
            <!-- ACCORDION VIEW END-->
          </div>
        </div>
      </div>
      <!-- ADVERTISING US END -->

      <div class="section-space-50"></div>
    </div>

    <!-- F&B APPLICATION SUBMITTED MODAL -->
    <b-modal
      ref="alertPopup"
      id="alertPopup"
      title="Request submitted"
      hide-footer
    >
      <div>
        <div class="p-3">
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
            <div class="row my-4">
              <div class="col-12 text-center">
                <img src="@/assets/img/icons/check-icon.svg" alt="Success" />
              </div>
              <div class="col-12 text-center my-4">
                <p>
                  Your request for advertising was submitted successfully.
                  <br />We will get in touch with you soon!
                </p>
              </div>
              <div class="col-12">
                <button
                  class="btn btn-primary w-100"
                  @click="$bvModal.hide('alertPopup')"
                >
                  DONE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import { IMAGEURL } from "@/config";
import MasterService from "@/apiServices/MasterService";
import ExtrasService from "@/apiServices/ExtrasService";

export default {
  data() {
    return {
      ad_with_us: null,
      imgArray: [{ src: `` }],
      IMAGE_URL: IMAGEURL,
      image_1: null,
      image_2: null,
      image_3: null,
      image_4: null,
      image_5: null,
      image_6: null,
      user_name: null,
      user_email: null,
      user_number: null,
      organization_name: null,
      message: null,
      aboutUsSlider: {
        dots: false,
        arrows: true,
        slidesToShow: 1,
      },
      aboutUsSliderNew: {
        dots: false,
        arrows: true,
        slidesToShow: 1,
      },
      tab1: false,
      tab2: false,
      tab3: true,
      tab4: false,
      errorMessage: null,
      errorEmail: null,
      customer_care_email: null,
    };
  },
  beforeMount() {
    if (this.getIsUserLogged) {
      this.user_name = this.getLoggedUser.user_name;
      this.user_email = this.getLoggedUser.user_email;
      this.user_number = this.getLoggedUser.user_number.slice(-10);
    }
    this.getPageImages();
    this.showTabs(`tab1`);
    this.getAdWithUs();
    this.getCustomerCareEmail();
  },

  computed: {
    ...mapGetters(["getLoggedUser", "getIsUserLogged"]),
    plainEmail() {
      const temp = document.createElement('div');
      temp.innerHTML = this.customer_care_email;
      const link = temp.querySelector('a');
      return link ? link.textContent.trim() : '';
    }
  },
  methods: {
    showTabs(value) {
      if (value === "tab1") {
        this.tab1 = true;
        this.tab2 = false;
        this.tab3 = false;
        this.tab4 = false;
      } else if (value === "tab2") {
        this.tab1 = false;
        this.tab2 = true;
        this.tab3 = false;
        this.tab4 = false;
      } else if (value === "tab3") {
        this.tab1 = false;
        this.tab2 = false;
        this.tab3 = true;
        this.tab4 = false;
      } else if (value === "tab4") {
        this.tab1 = false;
        this.tab2 = false;
        this.tab3 = false;
        this.tab4 = true;
      }
    },

    async handleSubmit(e) {
      this.errorMessage = null;
      this.errorEmail = null;
      if(String(this.user_number).length !== 10 || /(\d)\1{9}/.test(this.user_number)){
        this.errorMessage = "Enter Valid Mobile No.";
        this.$nextTick(() => {
          this.$refs.mobileNumber.focus();
        });
        return false;
      }
      if (!this.user_email || !/\S+@\S+\.\S+/.test(this.user_email)) {
        this.errorEmail = "Enter Valid Email Address";
        this.$nextTick(() => {
          this.$refs.emailAddress.focus();
        });
        return false;
      }
      // e.preventDefault();
      const payload = {
        adu_fullname: this.user_name,
        adu_phone: this.user_number,
        adu_email: this.user_email,
        adu_org: this.organization_name,
        adu_message: this.message,
      };

      try {
        const response = await ExtrasService.adWithUs(payload);
        if (response.data.status) {
        }
      } catch (err) {
        console.log("Error in adWithUs  ", err);
      }

      this.user_name = null;
      this.user_number = null;
      this.user_email = null;
      this.organization_name = null;
      this.message = null;
      this.errorMessage = null;
      this.$bvModal.show("alertPopup");
    },

    async getPageImages() {
      const { data } = await MasterService.GetPageImages({
        page_code: "advertise_with_us",
      });
      if (data && data.status) {
        const {
          image_path_1,
          image_path_2,
          image_path_3,
          image_path_4,
          image_path_5,
          image_path_6,
        } = data.data;
        this.image_1 = image_path_1;
        this.image_2 = image_path_2;
        this.image_3 = image_path_3;
        this.image_4 = image_path_4;
        this.image_5 = image_path_5;
        this.image_6 = image_path_6;
      }
    },
    async getAdWithUs() {
      try {
        const response = await ExtrasService.getAdWithUs();
        if (response.data.status) {
          this.ad_with_us = response.data.data.extra_html_content;
        }
      } catch (err) {
        console.log("Error in getting contact us html ", err);
      }
    },
    async getCustomerCareEmail() {
      try {
        const response = await ExtrasService.getCustomerCareEmail();
        if (response.data.status) {
          this.customer_care_email = response.data.data.extra_html_content;
        }
      } catch (err) {
        console.log("Error in getting customer care email ", err);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/advertiseWithUs.vue